import createStore from "astrid-helpers/src/createStore";

export const [getTrack, setTrack, useTrack, onTrack] = createStore(1);
